export default __webpack_public_path__ + "static/media/shoes.a596cb01.jpg";